import React from 'react';
import { Box, Button, Heading, Image, Text } from '@chakra-ui/react';

interface Props {
	badgeIcon: string;
	name: string;
	setIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
	badgeTagLine: string;
}

const ActiveBadgeModal = ({ badgeIcon, name, setIsOpen, badgeTagLine }: Props) => {
	return (
		<Box position={'relative'} pb="30px" bgColor={'#FFFAFB'} borderRadius={'24px'}>
			<Image zIndex={10} pointerEvents={'none'} position="absolute" src="/images/confetti.gif" alt="img" />
			<Image w="100%" borderRadius={'16px'} src="https://masai-website-images.s3.ap-south-1.amazonaws.com/Ellipse_1867_3543d98073.svg" />
			<Heading
				color="#03081A"
				mt={{ base: '22px', md: '35px' }}
				left="50%"
				transform={'translate(-50%, -50%)'}
				top="16px"
				position={'absolute'}
				as="h3"
			>
				Congratulations!
			</Heading>
			{<Image mt="6px" w="133px" mx="auto" src={badgeIcon} />}

			<Box mt="16px" px="16px" textAlign={'center'}>
				<Text color="#3B3435" textStyle={'body1'}>
					You have unlocked
				</Text>
				<Heading as="h3" lineHeight={'32px'} fontSize={'24px'} fontWeight={600} color="#4358F6" mt="5px">
					{name}
				</Heading>

				<Text mt="8px" color="#3B3435" textStyle={'body1'}>
					{badgeTagLine}
				</Text>

				<Button
					mt="16px"
					_focus={{ outline: 'none' }}
					outline="none"
					onClick={() => {
						setIsOpen(true);
					}}
					bgColor={'#4358F6'}
					variant="primary"
				>
					Share
					<Image ml="8px" src="/images/streak-share.svg" />
				</Button>
			</Box>
		</Box>
	);
};

export default ActiveBadgeModal;
